/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Yoast AI Brand Insights API
 * API for AI-powered brand insights and analysis
 * OpenAPI spec version: 1.0.0
 */
export type AIProviderEnum =
  (typeof AIProviderEnum)[keyof typeof AIProviderEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AIProviderEnum = {
  openai: 'openai',
  perplexity: 'perplexity',
  anthropic: 'anthropic',
  gemini: 'gemini',
} as const;

export type AIModel = string;

/**
 * A supported content language name. Used as the output language for the brand's generated queries.
 */
export type LanguageEnum = (typeof LanguageEnum)[keyof typeof LanguageEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LanguageEnum = {
  English: 'English',
  Spanish: 'Spanish',
  French: 'French',
  German: 'German',
  Chinese: 'Chinese',
  Japanese: 'Japanese',
  Abkhazian: 'Abkhazian',
  Afar: 'Afar',
  Afrikaans: 'Afrikaans',
  Akan: 'Akan',
  Albanian: 'Albanian',
  Amharic: 'Amharic',
  Arabic: 'Arabic',
  Aragonese: 'Aragonese',
  Armenian: 'Armenian',
  Assamese: 'Assamese',
  Avaric: 'Avaric',
  Avestan: 'Avestan',
  Aymara: 'Aymara',
  Azerbaijani: 'Azerbaijani',
  Bambara: 'Bambara',
  Bangla: 'Bangla',
  Bashkir: 'Bashkir',
  Basque: 'Basque',
  Belarusian: 'Belarusian',
  Bhojpuri: 'Bhojpuri',
  Bislama: 'Bislama',
  Bosnian: 'Bosnian',
  Breton: 'Breton',
  Bulgarian: 'Bulgarian',
  Burmese: 'Burmese',
  Catalan: 'Catalan',
  Chamorro: 'Chamorro',
  Chechen: 'Chechen',
  Church_Slavic: 'Church Slavic',
  Chuvash: 'Chuvash',
  Cornish: 'Cornish',
  Corsican: 'Corsican',
  Cree: 'Cree',
  Croatian: 'Croatian',
  Czech: 'Czech',
  Danish: 'Danish',
  Divehi: 'Divehi',
  Dutch: 'Dutch',
  Dzongkha: 'Dzongkha',
  Esperanto: 'Esperanto',
  Estonian: 'Estonian',
  Ewe: 'Ewe',
  Faroese: 'Faroese',
  Fijian: 'Fijian',
  Finnish: 'Finnish',
  Fula: 'Fula',
  Galician: 'Galician',
  Ganda: 'Ganda',
  Georgian: 'Georgian',
  Greek: 'Greek',
  Guarani: 'Guarani',
  Gujarati: 'Gujarati',
  Haitian_Creole: 'Haitian Creole',
  Hausa: 'Hausa',
  Hebrew: 'Hebrew',
  Herero: 'Herero',
  Hindi: 'Hindi',
  Hiri_Motu: 'Hiri Motu',
  Hungarian: 'Hungarian',
  Icelandic: 'Icelandic',
  Ido: 'Ido',
  Igbo: 'Igbo',
  Indonesian: 'Indonesian',
  Interlingua: 'Interlingua',
  Interlingue: 'Interlingue',
  Inuktitut: 'Inuktitut',
  Inupiaq: 'Inupiaq',
  Irish: 'Irish',
  Italian: 'Italian',
  Javanese: 'Javanese',
  Kalaallisut: 'Kalaallisut',
  Kannada: 'Kannada',
  Kanuri: 'Kanuri',
  Kashmiri: 'Kashmiri',
  Kazakh: 'Kazakh',
  Khmer: 'Khmer',
  Kikuyu: 'Kikuyu',
  Kinyarwanda: 'Kinyarwanda',
  Komi: 'Komi',
  Kongo: 'Kongo',
  Korean: 'Korean',
  Kuanyama: 'Kuanyama',
  Kurdish: 'Kurdish',
  Kyrgyz: 'Kyrgyz',
  Lao: 'Lao',
  Latin: 'Latin',
  Latvian: 'Latvian',
  Limburgish: 'Limburgish',
  Lingala: 'Lingala',
  Lithuanian: 'Lithuanian',
  'Luba-Katanga': 'Luba-Katanga',
  Luxembourgish: 'Luxembourgish',
  Macedonian: 'Macedonian',
  Malagasy: 'Malagasy',
  Malay: 'Malay',
  Malayalam: 'Malayalam',
  Maltese: 'Maltese',
  Manx: 'Manx',
  Marathi: 'Marathi',
  Marshallese: 'Marshallese',
  Mongolian: 'Mongolian',
  Māori: 'Māori',
  Nauru: 'Nauru',
  Navajo: 'Navajo',
  Ndonga: 'Ndonga',
  Nepali: 'Nepali',
  North_Ndebele: 'North Ndebele',
  Northern_Sami: 'Northern Sami',
  Norwegian: 'Norwegian',
  Norwegian_Bokmål: 'Norwegian Bokmål',
  Norwegian_Nynorsk: 'Norwegian Nynorsk',
  Nyanja: 'Nyanja',
  Occitan: 'Occitan',
  Odia: 'Odia',
  Ojibwa: 'Ojibwa',
  Oromo: 'Oromo',
  Ossetic: 'Ossetic',
  Pali: 'Pali',
  Pashto: 'Pashto',
  Persian: 'Persian',
  Polish: 'Polish',
  Portuguese: 'Portuguese',
  Punjabi: 'Punjabi',
  Quechua: 'Quechua',
  Romanian: 'Romanian',
  Romansh: 'Romansh',
  Rundi: 'Rundi',
  Russian: 'Russian',
  Samoan: 'Samoan',
  Sango: 'Sango',
  Sanskrit: 'Sanskrit',
  Sardinian: 'Sardinian',
  Scottish_Gaelic: 'Scottish Gaelic',
  Serbian: 'Serbian',
  Shona: 'Shona',
  Sichuan_Yi: 'Sichuan Yi',
  Sindhi: 'Sindhi',
  Sinhala: 'Sinhala',
  Slovak: 'Slovak',
  Slovenian: 'Slovenian',
  Somali: 'Somali',
  South_Ndebele: 'South Ndebele',
  Southern_Sotho: 'Southern Sotho',
  Sundanese: 'Sundanese',
  Swahili: 'Swahili',
  Swati: 'Swati',
  Swedish: 'Swedish',
  Tagalog: 'Tagalog',
  Tahitian: 'Tahitian',
  Tajik: 'Tajik',
  Tamil: 'Tamil',
  Tatar: 'Tatar',
  Telugu: 'Telugu',
  Thai: 'Thai',
  Tibetan: 'Tibetan',
  Tigrinya: 'Tigrinya',
  Tongan: 'Tongan',
  Tsonga: 'Tsonga',
  Tswana: 'Tswana',
  Turkish: 'Turkish',
  Turkmen: 'Turkmen',
  Twi: 'Twi',
  Ukrainian: 'Ukrainian',
  Urdu: 'Urdu',
  Uyghur: 'Uyghur',
  Uzbek: 'Uzbek',
  Venda: 'Venda',
  Vietnamese: 'Vietnamese',
  Volapük: 'Volapük',
  Walloon: 'Walloon',
  Welsh: 'Welsh',
  Western_Frisian: 'Western Frisian',
  Wolof: 'Wolof',
  Xhosa: 'Xhosa',
  Yiddish: 'Yiddish',
  Yoruba: 'Yoruba',
  Zhuang: 'Zhuang',
  Zulu: 'Zulu',
} as const;

export type BrandStatusEnum =
  (typeof BrandStatusEnum)[keyof typeof BrandStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandStatusEnum = {
  pendingQuerySelection: 'pendingQuerySelection',
  scheduledFirstAnalysis: 'scheduledFirstAnalysis',
  firstAnalysisInProgress: 'firstAnalysisInProgress',
  firstAnalysisNotScheduled: 'firstAnalysisNotScheduled',
  completed: 'completed',
} as const;

/**
 * Categories for citation sources
 */
export type CitationCategoryEnum =
  (typeof CitationCategoryEnum)[keyof typeof CitationCategoryEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CitationCategoryEnum = {
  Publisher: 'Publisher',
  Social_media: 'Social media',
  Business: 'Business',
  Other: 'Other',
} as const;

/**
 * Impact levels for citation sources
 */
export type CitationImpactEnum =
  (typeof CitationImpactEnum)[keyof typeof CitationImpactEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CitationImpactEnum = {
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
} as const;

/**
 * Universally Unique Lexicographically Sortable Identifier
 */
export type Ulid = string;

/**
 * Generic URL field
 */
export type Url = string;

/**
 * Percentage value
 * @minimum 0
 * @maximum 100
 */
export type Percentage = number;

/**
 * @minLength 1
 * @maxLength 255
 */
export type BrandName = string;

/**
 * @minLength 1
 * @maxLength 1000
 */
export type BrandDescription = string;

export type BrandUrl = Url;

/**
 * ISO 3166-1 alpha-2 country code (plus "XK" for Kosovo).
 */
export type Country = (typeof Country)[keyof typeof Country];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Country = {
  AD: 'AD',
  AE: 'AE',
  AF: 'AF',
  AG: 'AG',
  AI: 'AI',
  AL: 'AL',
  AM: 'AM',
  AO: 'AO',
  AQ: 'AQ',
  AR: 'AR',
  AS: 'AS',
  AT: 'AT',
  AU: 'AU',
  AW: 'AW',
  AX: 'AX',
  AZ: 'AZ',
  BA: 'BA',
  BB: 'BB',
  BD: 'BD',
  BE: 'BE',
  BF: 'BF',
  BG: 'BG',
  BH: 'BH',
  BI: 'BI',
  BJ: 'BJ',
  BL: 'BL',
  BM: 'BM',
  BN: 'BN',
  BO: 'BO',
  BQ: 'BQ',
  BR: 'BR',
  BS: 'BS',
  BT: 'BT',
  BV: 'BV',
  BW: 'BW',
  BY: 'BY',
  BZ: 'BZ',
  CA: 'CA',
  CC: 'CC',
  CD: 'CD',
  CF: 'CF',
  CG: 'CG',
  CH: 'CH',
  CI: 'CI',
  CK: 'CK',
  CL: 'CL',
  CM: 'CM',
  CN: 'CN',
  CO: 'CO',
  CR: 'CR',
  CU: 'CU',
  CV: 'CV',
  CW: 'CW',
  CX: 'CX',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DJ: 'DJ',
  DK: 'DK',
  DM: 'DM',
  DO: 'DO',
  DZ: 'DZ',
  EC: 'EC',
  EE: 'EE',
  EG: 'EG',
  EH: 'EH',
  ER: 'ER',
  ES: 'ES',
  ET: 'ET',
  FI: 'FI',
  FJ: 'FJ',
  FK: 'FK',
  FM: 'FM',
  FO: 'FO',
  FR: 'FR',
  GA: 'GA',
  GB: 'GB',
  GD: 'GD',
  GE: 'GE',
  GF: 'GF',
  GG: 'GG',
  GH: 'GH',
  GI: 'GI',
  GL: 'GL',
  GM: 'GM',
  GN: 'GN',
  GP: 'GP',
  GQ: 'GQ',
  GR: 'GR',
  GS: 'GS',
  GT: 'GT',
  GU: 'GU',
  GW: 'GW',
  GY: 'GY',
  HK: 'HK',
  HM: 'HM',
  HN: 'HN',
  HR: 'HR',
  HT: 'HT',
  HU: 'HU',
  ID: 'ID',
  IE: 'IE',
  IL: 'IL',
  IM: 'IM',
  IN: 'IN',
  IO: 'IO',
  IQ: 'IQ',
  IR: 'IR',
  IS: 'IS',
  IT: 'IT',
  JE: 'JE',
  JM: 'JM',
  JO: 'JO',
  JP: 'JP',
  KE: 'KE',
  KG: 'KG',
  KH: 'KH',
  KI: 'KI',
  KM: 'KM',
  KN: 'KN',
  KP: 'KP',
  KR: 'KR',
  KW: 'KW',
  KY: 'KY',
  KZ: 'KZ',
  LA: 'LA',
  LB: 'LB',
  LC: 'LC',
  LI: 'LI',
  LK: 'LK',
  LR: 'LR',
  LS: 'LS',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  LY: 'LY',
  MA: 'MA',
  MC: 'MC',
  MD: 'MD',
  ME: 'ME',
  MF: 'MF',
  MG: 'MG',
  MH: 'MH',
  MK: 'MK',
  ML: 'ML',
  MM: 'MM',
  MN: 'MN',
  MO: 'MO',
  MP: 'MP',
  MQ: 'MQ',
  MR: 'MR',
  MS: 'MS',
  MT: 'MT',
  MU: 'MU',
  MV: 'MV',
  MW: 'MW',
  MX: 'MX',
  MY: 'MY',
  MZ: 'MZ',
  NA: 'NA',
  NC: 'NC',
  NE: 'NE',
  NF: 'NF',
  NG: 'NG',
  NI: 'NI',
  NL: 'NL',
  NO: 'NO',
  NP: 'NP',
  NR: 'NR',
  NU: 'NU',
  NZ: 'NZ',
  OM: 'OM',
  PA: 'PA',
  PE: 'PE',
  PF: 'PF',
  PG: 'PG',
  PH: 'PH',
  PK: 'PK',
  PL: 'PL',
  PM: 'PM',
  PN: 'PN',
  PR: 'PR',
  PS: 'PS',
  PT: 'PT',
  PW: 'PW',
  PY: 'PY',
  QA: 'QA',
  RE: 'RE',
  RO: 'RO',
  RS: 'RS',
  RU: 'RU',
  RW: 'RW',
  SA: 'SA',
  SB: 'SB',
  SC: 'SC',
  SD: 'SD',
  SE: 'SE',
  SG: 'SG',
  SH: 'SH',
  SI: 'SI',
  SJ: 'SJ',
  SK: 'SK',
  SL: 'SL',
  SM: 'SM',
  SN: 'SN',
  SO: 'SO',
  SR: 'SR',
  SS: 'SS',
  ST: 'ST',
  SV: 'SV',
  SX: 'SX',
  SY: 'SY',
  SZ: 'SZ',
  TC: 'TC',
  TD: 'TD',
  TF: 'TF',
  TG: 'TG',
  TH: 'TH',
  TJ: 'TJ',
  TK: 'TK',
  TL: 'TL',
  TM: 'TM',
  TN: 'TN',
  TO: 'TO',
  TR: 'TR',
  TT: 'TT',
  TV: 'TV',
  TW: 'TW',
  TZ: 'TZ',
  UA: 'UA',
  UG: 'UG',
  UM: 'UM',
  US: 'US',
  UY: 'UY',
  UZ: 'UZ',
  VA: 'VA',
  VC: 'VC',
  VE: 'VE',
  VG: 'VG',
  VI: 'VI',
  VN: 'VN',
  VU: 'VU',
  WF: 'WF',
  WS: 'WS',
  XK: 'XK',
  YE: 'YE',
  YT: 'YT',
  ZA: 'ZA',
  ZM: 'ZM',
  ZW: 'ZW',
  Global: 'Global',
} as const;

export type Region = string;

export type City = string;

export type DateTime = string;

/**
 * @minimum 0
 */
export type Count = number;

export type ChartDataDatasetsItem = {
  label: string;
  data: number[];
};

/**
 * Generic chart data structure with labels and corresponding data points for graphing purposes
 */
export interface ChartData {
  labels: string[];
  datasets: ChartDataDatasetsItem[];
}

export type ScoreValue = number | Percentage;

/**
 * Comparison of current score with a previous score
 */
export interface ScoreComparison {
  value: ScoreValue;
  difference: number;
  /**
   * Percentage change from the previous score to the current score. Null if previous score was zero.
   * @nullable
   */
  percentageChange: number | null;
}

/**
 * @nullable
 */
export type ScorePrevious = ScoreComparison | null;

export interface Score {
  value: ScoreValue;
  /** @nullable */
  previous?: ScorePrevious;
}

export type ScoresStandardized = {
  visibility: Score;
  mentions: Score;
  ranking: Score;
  citations: Score;
  sentiment: Score;
};

/**
 * Detailed scoring information for scan results
 */
export interface Scores {
  standardized?: ScoresStandardized;
}

/**
 * The AI provider whose scan these metrics come from — the requested one when available, otherwise the first completed scan.
 * @nullable
 */
export type AnalysisSummaryAiProvider = AIProviderEnum | null;

/**
 * @nullable
 */
export type AnalysisSummaryRanking = Score | null;

/**
 * Headline metrics for the latest completed analysis, for a single AI provider, used by the homepage summary card.
 */
export interface AnalysisSummary {
  analysisId: Ulid;
  /**
   * The AI provider whose scan these metrics come from — the requested one when available, otherwise the first completed scan.
   * @nullable
   */
  aiProvider?: AnalysisSummaryAiProvider;
  createdAt: string;
  mentions: Score;
  /** @nullable */
  ranking?: AnalysisSummaryRanking;
  citations: Score;
  sentiment: Score;
}

export type QueryMentionScoreQueriesWithMentionsItemAllOf = {
  /** Whether the own brand was mentioned in the query result */
  mentioned: boolean;
};

export type QueryMentionScoreQueriesWithMentionsItem = QueryObject &
  QueryMentionScoreQueriesWithMentionsItemAllOf;

/**
 * Array of query objects indicating if the own brand was mentioned in the results for each query
 */
export interface QueryMentionScore {
  mentionedInNumberOfQueries: Score;
  chart: ChartData;
  queriesWithMentions: QueryMentionScoreQueriesWithMentionsItem[];
}

export type RankScoreListItemBrand = {
  name: BrandName;
  numberOfMentions: Score;
  /** Indicates if this brand is the user's own brand */
  isSelf: boolean;
};

export type RankScoreListItem = {
  id: Ulid;
  rank: Score;
  brand: RankScoreListItemBrand;
};

/**
 * Rank of your own and competitor's brands in the AI results
 */
export interface RankScore {
  list: RankScoreListItem[];
}

export type CitationScoreListItemAssociatedBrandsItem = {
  id: Ulid;
  name: string;
  isSelf: boolean;
};

export type CitationScoreListItem = {
  url: Url;
  rootDomain: string;
  category: CitationCategoryEnum;
  impact: CitationImpactEnum;
  numberOfMentions: Score;
  isBrand: boolean;
  associatedBrands: CitationScoreListItemAssociatedBrandsItem[];
};

/**
 * The result of the citations analysis for a scan. Tracks which sources were cited by the AI in the results.
 */
export interface CitationScore {
  total: Score;
  ownBrandTotal: Score;
  categories: CitationCategoryEnum[];
  list: CitationScoreListItem[];
}

export type SentimentScoreKeywords = {
  positive: string[];
  negative: string[];
};

/**
 * The sentiment analysis result for a scan for a brand
 */
export interface SentimentScore {
  brandName: BrandName;
  positivityPercentage: Score;
  keywords: SentimentScoreKeywords;
}

/**
 * @nullable
 */
export type SentimentScoresOwn = SentimentScore | null;

/**
 * @nullable
 */
export type SentimentScoresTopCompetitor = SentimentScore | null;

/**
 * Sentiment scores for your brand and your top competitor
 */
export interface SentimentScores {
  /** @nullable */
  own: SentimentScoresOwn;
  /** @nullable */
  topCompetitor: SentimentScoresTopCompetitor;
}

export type ScanId = Ulid;

export type ScanStatus = (typeof ScanStatus)[keyof typeof ScanStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScanStatus = {
  pending: 'pending',
  in_progress: 'in_progress',
  completed: 'completed',
  updating: 'updating',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

/**
 * @nullable
 */
export type ScanAiModel = AIModel | null;

/**
 * @nullable
 */
export type ScanFinishedAt = DateTime | null;

/**
 * Detailed scan object with all properties
 */
export interface Scan {
  id: Ulid;
  aiProvider?: AIProviderEnum;
  /** @nullable */
  aiModel?: ScanAiModel;
  status: ScanStatus;
  startedAt: DateTime;
  /** @nullable */
  finishedAt: ScanFinishedAt;
  /** Indicates if the scan is up to date with the current brand group associations. When this is false, the results may not be reliable until the scan is updated. Recent scans are automatically updated in the background. */
  isUpToDateWithBrandGroups: boolean;
  /** Whether this scan is eligible to be manually retried. Only true for failed scans that meet the manual retry criteria. */
  canManualRetry: boolean;
  /**
   * Number of times this scan has been manually retried. 0 means no manual retries have been attempted.
   * @minimum 0
   */
  manualRetryCount: number;
  /**
   * ISO 8601 datetime when the next manual retry becomes available. Null when a retry is available now or when no future retry is possible (use canManualRetry to distinguish).
   * @nullable
   */
  nextManualRetryAfter: string | null;
  scores?: Scores;
  numberOfQueries?: Count;
  mentions?: QueryMentionScore;
  citations?: CitationScore;
  rankings?: RankScore;
  sentiment?: SentimentScores;
}

export type AnalysisId = Ulid;

export type AnalysisStatus =
  (typeof AnalysisStatus)[keyof typeof AnalysisStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalysisStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;

/**
 * @nullable
 */
export type AnalysisBaseStatus = AnalysisStatus | null;

/**
 * Core analysis properties shared across all analysis representations
 */
export interface AnalysisBase {
  id: Ulid;
  /** @nullable */
  status?: AnalysisBaseStatus;
  aiviScore: Score;
  createdAt: DateTime;
  completedAt: DateTime;
}

/**
 * @nullable
 */
export type AnalysisListItemCompletedAt = DateTime | null;

/**
 * Slim analysis representation used in brand analysis listings
 */
export interface AnalysisListItem {
  id: Ulid;
  status: AnalysisStatus;
  createdAt: DateTime;
  /** @nullable */
  completedAt: AnalysisListItemCompletedAt;
}

export type AnalysisDetailedAllOf = {
  /** Scans that completed successfully (with scores and results) */
  completedScans: Scan[];
  /** Scans that failed to complete */
  failedScans: Scan[];
  /** Scans that are pending or still processing */
  pendingScans: Scan[];
};

/**
 * Complete analysis object with full data and scoring
 */
export type AnalysisDetailed = AnalysisBase & AnalysisDetailedAllOf;

/**
 * An analysis identifier or the string literal "latest"
 */
export type AnalysisIdOrLatest = string | 'latest';

/**
 * @minLength 3
 * @maxLength 500
 */
export type Query = string;

/**
 * Array of query strings
 */
export type Queries = Query[];

export type QueryId = Ulid;

/**
 * Detailed query object with ID and query string
 */
export interface QueryObject {
  id: Ulid;
  query: Query;
}

/**
 * Array of detailed query objects
 */
export type QueryObjects = QueryObject[];

export type QueryResultId = Ulid;

/**
 * The raw API response from the AI provider, containing the full unprocessed response data
 * @nullable
 */
export type QueryResultDetailedRawResponse = { [key: string]: unknown } | null;

export type QueryResultDetailedMentionedBrandsItem = {
  id: Ulid;
  name: string;
  isSelf: boolean;
  /** Position in which the brand was mentioned */
  rank: number;
  /** Context/snippet where the brand was mentioned */
  context: string;
};

export type QueryResultDetailedCitationsItemAssociatedBrandsItem = {
  id: Ulid;
  name: string;
  isSelf: boolean;
};

export type QueryResultDetailedCitationsItem = {
  url: string;
  rootDomain: string;
  category: CitationCategoryEnum;
  impact: CitationImpactEnum;
  /** Position of the citation in the response */
  rank: number;
  associatedBrands: QueryResultDetailedCitationsItemAssociatedBrandsItem[];
};

export type QueryResultDetailedSentimentsItemBrandsItem = {
  id: Ulid;
  name: string;
  isSelf: boolean;
};

export type QueryResultDetailedSentimentsItemKeywordsItem = {
  keyword: string;
  /** Sentiment value (-1 to 1) */
  sentiment: number;
  isPositive: boolean;
  isNeutral: boolean;
  isNegative: boolean;
};

export type QueryResultDetailedSentimentsItem = {
  id: Ulid;
  /** Sentiment score */
  score: number;
  /** Confidence level of the sentiment analysis */
  confidence: number;
  /** Brands this sentiment analysis applies to */
  brands: QueryResultDetailedSentimentsItemBrandsItem[];
  /** Keywords extracted with their sentiment values */
  keywords: QueryResultDetailedSentimentsItemKeywordsItem[];
};

/**
 * Detailed query result with full AI response, mentioned brands, citations, and sentiment analysis
 */
export interface QueryResultDetailed {
  id: Ulid;
  query: Query;
  /** The AI's full response text for this query */
  response: string;
  /**
   * The raw API response from the AI provider, containing the full unprocessed response data
   * @nullable
   */
  rawResponse: QueryResultDetailedRawResponse;
  /** Array of all brands mentioned in the query result with context */
  mentionedBrands: QueryResultDetailedMentionedBrandsItem[];
  /** Array of citations/URLs mentioned in the query result */
  citations: QueryResultDetailedCitationsItem[];
  /** Array of sentiment analyses for different brand groups */
  sentiments: QueryResultDetailedSentimentsItem[];
}

export type AssociatedBrandId = Ulid;

export type AssociatedBrandGroupId = Ulid;

/**
 * Request to create a brand association group
 */
export interface BrandAssociationRequest {
  groupName: string;
  brandIds: Ulid[];
}

/**
 * Request to update properties of an associated brand
 */
export interface AssociatedBrandUpdateRequest {
  isHidden?: boolean;
}

export type AssociatedBrandsResponseAssociatedBrandsItem =
  | UngroupedAssociatedBrand
  | GroupedAssociatedBrand;

/**
 * Response containing associated brands data
 */
export interface AssociatedBrandsResponse {
  associatedBrands: AssociatedBrandsResponseAssociatedBrandsItem[];
}

export type UngroupedAssociatedBrandType =
  (typeof UngroupedAssociatedBrandType)[keyof typeof UngroupedAssociatedBrandType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UngroupedAssociatedBrandType = {
  item: 'item',
} as const;

/**
 * Represents an associated brand that is not part of any group
 */
export interface UngroupedAssociatedBrand {
  type: UngroupedAssociatedBrandType;
  id: Ulid;
  name: string;
  isHidden: boolean;
  /** Indicates if this brand is the user's own brand */
  isSelf: boolean;
}

export type GroupedAssociatedBrandType =
  (typeof GroupedAssociatedBrandType)[keyof typeof GroupedAssociatedBrandType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GroupedAssociatedBrandType = {
  group: 'group',
} as const;

/**
 * Represents an associated brand that is part of a group
 */
export interface GroupedAssociatedBrand {
  type: GroupedAssociatedBrandType;
  id: Ulid;
  name: string;
  isHidden: boolean;
  /** Indicates if this group is owned by the user */
  isSelf: boolean;
  groupedBrands: UngroupedAssociatedBrand[];
}

/**
 * Settings related to a brand
 */
export interface BrandSettings {
  enableAutomaticAnalysis: boolean;
  enableNotifications: boolean;
  /** AI providers to exclude from automatic analyses. By default, all configured providers are used. */
  excludedAnalysisProviders: AIProviderEnum[];
  createdAt: DateTime;
  updatedAt: DateTime;
}

/**
 * Only the setting values without the rest of the model properties
 */
export interface BrandSettingValues {
  enableAutomaticAnalysis?: boolean;
  enableNotifications?: boolean;
  showAutomaticAnalysisDisabledNotification?: boolean;
  /** AI providers to exclude from automatic analyses. By default, all configured providers are used. */
  excludedAnalysisProviders?: AIProviderEnum[];
}

export type UserId = Ulid;

/**
 * User information
 */
export interface User {
  id?: Ulid;
  /**
   * @minLength 1
   * @maxLength 100
   */
  displayName?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  firstName?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  lastName?: string;
  email?: string;
}

/**
 * Response containing user and their brands
 */
export interface UserResponse {
  user?: User;
  brands?: Brand[];
}

export type BrandId = Ulid;

/**
 * @nullable
 */
export type BrandUrlProperty = Url | null;

/**
 * @nullable
 */
export type BrandCountry = Country | null;

/**
 * @nullable
 */
export type BrandRegion = Region | null;

/**
 * @nullable
 */
export type BrandCity = City | null;

/**
 * @nullable
 */
export type BrandNextScheduledAnalysis = DateTime | null;

/**
 * @nullable
 */
export type BrandFirstNextAnalysisOpportunity = DateTime | null;

/**
 * Complete brand object with all properties
 */
export interface Brand {
  id: Ulid;
  name: BrandName;
  /** @nullable */
  url: BrandUrlProperty;
  description: BrandDescription;
  focusLanguage: LanguageEnum;
  /** @nullable */
  country?: BrandCountry;
  /** @nullable */
  region?: BrandRegion;
  /** @nullable */
  city?: BrandCity;
  setupStatus: BrandStatusEnum;
  /** @nullable */
  nextScheduledAnalysis?: BrandNextScheduledAnalysis;
  /** @nullable */
  firstNextAnalysisOpportunity?: BrandFirstNextAnalysisOpportunity;
  createdAt: DateTime;
  hasAnalysisInProgress?: boolean;
}

export type BrandsBrandsItemAllOf = {
  settings: BrandSettingValues;
};

export type BrandsBrandsItem = Brand & BrandsBrandsItemAllOf;

/**
 * A list of brands
 */
export interface Brands {
  brands: BrandsBrandsItem[];
}

export type BrandDetailedAllOf = {
  queries: QueryObjects;
};

/**
 * Extended brand object with lifecycle and summary information
 */
export type BrandDetailed = Brand & BrandDetailedAllOf;

/**
 * @nullable
 */
export type BrandCreateUrl = Url | null;

/**
 * @nullable
 */
export type BrandCreateCountry = Country | null;

/**
 * When the brand is created from the onboarding chat, the final server-signed transcript. The server verifies it and records how many messages the onboarding took as an internal, server-side-only metric (not returned in any response). Omit for brands created via the Setup wizard.
 * @nullable
 */
export type BrandCreateSignedTranscript = SignedTranscript | null;

/**
 * Brand object for creation requests (without id and createdAt)
 */
export interface BrandCreate {
  name: BrandName;
  /** @nullable */
  url?: BrandCreateUrl;
  description: BrandDescription;
  focusLanguage: LanguageEnum;
  /** @nullable */
  country?: BrandCreateCountry;
  /**
   * The region the brand serves.
   * @maxLength 100
   * @nullable
   */
  region?: string | null;
  /**
   * The city the brand serves.
   * @maxLength 100
   * @nullable
   */
  city?: string | null;
  /**
   * The brand's main products or services. Soft limit of 5 items; more are accepted.
   * @nullable
   */
  keyOfferings?: string[] | null;
  /**
   * Alternative names, spellings, or abbreviations people might use when searching for the brand. Soft limit of 10 items; more are accepted.
   * @nullable
   */
  brandAliases?: string[] | null;
  /**
   * Other brands competing for the same audience. Soft limit of 3 items; more are accepted.
   * @nullable
   */
  competitors?: string[] | null;
  /**
   * The brand's target customers.
   * @maxLength 255
   * @nullable
   */
  targetAudience?: string | null;
  /**
   * The industry the brand operates in.
   * @maxLength 255
   * @nullable
   */
  industry?: string | null;
  /**
   * What makes the brand special or different from competitors.
   * @maxLength 255
   * @nullable
   */
  uniqueValue?: string | null;
  /**
   * When the brand is created from the onboarding chat, the final server-signed transcript. The server verifies it and records how many messages the onboarding took as an internal, server-side-only metric (not returned in any response). Omit for brands created via the Setup wizard.
   * @nullable
   */
  signedTranscript?: BrandCreateSignedTranscript;
}

/**
 * Standard error response format
 */
export interface ErrorResponse {
  error?: string;
}

/**
 * An object containing a success message
 */
export interface SuccessMessage {
  message?: string;
}

/**
 * @nullable
 */
export type ValidationErrorErrors = { [key: string]: unknown } | null;

/**
 * Validation error response
 */
export interface ValidationError {
  message?: string;
  /** @nullable */
  errors?: ValidationErrorErrors;
}

/**
 * Resource not found error response
 */
export interface NotFoundError {
  error?: string;
}

/**
 * Unauthenticated or unauthorized access error response
 */
export interface UnauthorizedError {
  error?: string;
}

/**
 * Payment required error response
 */
export interface PaymentRequiredError {
  error?: string;
}

/**
 * Forbidden access error response
 */
export interface ForbiddenError {
  error?: string;
}

/**
 * Success response containing message and data
 */
export interface SuccessResponseWithData {
  /** Success message */
  message?: string;
  /** Response data (varies by endpoint) */
  data?: unknown;
}

export type ModerationFlaggedQueryCategories = { [key: string]: unknown };

export type ModerationFlaggedQueryCategoryScores = { [key: string]: unknown };

/**
 * @nullable
 */
export type ModerationFlaggedQueryDetails = { [key: string]: unknown } | null;

/**
 * A query flagged by OpenAI moderation endpoint
 */
export interface ModerationFlaggedQuery {
  query: string;
  categories?: ModerationFlaggedQueryCategories;
  category_scores?: ModerationFlaggedQueryCategoryScores;
  /** @nullable */
  error?: string | null;
  /** @nullable */
  details?: ModerationFlaggedQueryDetails;
}

/**
 * Response returned when queries are flagged by moderation
 */
export interface ModerationErrorResponse {
  error: string;
  flagged_queries: ModerationFlaggedQuery[];
}

/**
 * @nullable
 */
export type OnboardingProfileTargetLanguage = LanguageEnum | null;

/**
 * @nullable
 */
export type OnboardingProfileTargetGeographyCountry = Country | null;

export type OnboardingProfileTargetGeography = {
  /** @nullable */
  country?: OnboardingProfileTargetGeographyCountry;
  /**
   * A region, "None", or null.
   * @nullable
   */
  region?: string | null;
  /**
   * A city, "None", or null.
   * @nullable
   */
  city?: string | null;
};

/**
 * The structured brand profile. The model echoes the whole object every turn; the sidebar renders target_geography as three separately-editable fields (country/region/city).
 */
export interface OnboardingProfile {
  /** @nullable */
  brand_name?: string | null;
  /**
   * Max 1000 chars.
   * @nullable
   */
  description?: string | null;
  /** @nullable */
  website_url?: string | null;
  /** @nullable */
  target_language?: OnboardingProfileTargetLanguage;
  target_geography?: OnboardingProfileTargetGeography;
  /** Soft limit of 5; user edits may exceed it. */
  key_offerings?: string[];
  brand_aliases?: string[];
  /** @nullable */
  target_audience?: string | null;
  /** @nullable */
  industry?: string | null;
  /** Soft limit of 3; user edits may exceed it. */
  competitors?: string[];
  /**
   * What makes the brand special/different; inferred from the brand.
   * @nullable
   */
  unique_value?: string | null;
}

export type SignedTranscriptTranscriptItemRole =
  (typeof SignedTranscriptTranscriptItemRole)[keyof typeof SignedTranscriptTranscriptItemRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SignedTranscriptTranscriptItemRole = {
  user: 'user',
  assistant: 'assistant',
} as const;

export type SignedTranscriptTranscriptItem = {
  role: SignedTranscriptTranscriptItemRole;
  content: string;
};

/**
 * Opaque, server-signed (HMAC) conversation state. The client stores and echoes it verbatim each turn and never edits it; the server verifies it before trusting the history.
 */
export interface SignedTranscript {
  transcript: SignedTranscriptTranscriptItem[];
  profile: OnboardingProfile;
  /** HMAC signature over the canonical transcript + profile. */
  sig: string;
}

/**
 * The structured result of one turn. Readiness (brand_name + description) is computed in code, not carried here.
 */
export interface OnboardingChatTurn {
  profile: OnboardingProfile;
  assistant_message: string;
}

export type OnboardingChatDoneCitationsItem = {
  url?: string;
  /** @nullable */
  title?: string | null;
};

/**
 * Dev-only per-turn cost estimate (present only when DEBUG_METRICS is enabled).
 * @nullable
 */
export type OnboardingChatDoneCost = {
  input_tokens?: number;
  output_tokens?: number;
  web_search_calls?: number;
  total_cost?: number;
} | null;

/**
 * The payload of the final `done` SSE event: the structured turn and the re-signed transcript to echo next turn. `cost` is dev-only and absent in production.
 */
export interface OnboardingChatDone {
  turn: OnboardingChatTurn;
  signedTranscript: SignedTranscript;
  /** Web sources the research actually used (url_citation annotations). Best-effort — may be empty. Rendered as subtle favicon chips under the assistant reply. */
  citations?: OnboardingChatDoneCitationsItem[];
  /**
   * Dev-only per-turn cost estimate (present only when DEBUG_METRICS is enabled).
   * @nullable
   */
  cost?: OnboardingChatDoneCost;
}

/**
 * The operation was successful
 */
export type SuccessMessageResponse = SuccessMessage;

/**
 * The request data was invalid
 */
export type ValidationErrorResponse = ValidationError;

/**
 * Something's wrong with the request. Repeating this request will not yield a different result. Check the error message for details.
 */
export type BadRequestResponse = ErrorResponse;

/**
 * No or invalid credentials provided for the requested route
 */
export type UnauthorizedResponse = UnauthorizedError;

/**
 * Payment required to access this resource or perform this action
 */
export type PaymentRequiredResponse = PaymentRequiredError;

/**
 * Forbidden
 */
export type ForbiddenResponse = ForbiddenError;

/**
 * Resource not found
 */
export type NotFoundResponse = NotFoundError;

export type GetAnalysisList200 = {
  analyses: AnalysisListItem[];
};

export type PostAnalysisBody = {
  providers: AIProviderEnum[];
};

export type PostAnalysis201 = {
  analysis: AnalysisBase;
};

export type DeleteAnalysis200 = {
  message: string;
  deleted_count: number;
};

export type PostTrialAnalysis201 = {
  analysis: AnalysisBase;
};

export type GetAnalysis200 = {
  analysis: AnalysisDetailed;
};

export type DeleteSingleAnalysis200 = {
  message: string;
};

export type DeleteScan200 = {
  message?: string;
};

export type DeleteScan400 = {
  error?: string;
};

export type ManualRetryScan202 = {
  message?: string;
  scanId?: string;
};

export type ManualRetryScan400 = {
  error?: string;
};

export type GetAnalysisSummaryParams = {
  /**
   * Return the metrics for this AI provider instead of the first completed scan. Ignored when the latest completed analysis has no completed scan for it.
   */
  aiProvider?: AIProviderEnum;
};

/**
 * @nullable
 */
export type GetAnalysisSummary200Summary = AnalysisSummary | null;

export type GetAnalysisSummary200 = {
  /** @nullable */
  summary?: GetAnalysisSummary200Summary;
  /** AI providers with a completed scan in the latest completed analysis, in the same order the dashboard lists them. Empty when there is nothing to show. */
  providers: AIProviderEnum[];
};

export type GetAnalysisStatus200 = {
  id: Ulid;
  status: AnalysisStatus;
  completedQueries: Ulid[];
};

export type GetScanQueryResults200 = {
  queryResults: QueryResultDetailed[];
};

export type LoginBody = {
  email: string;
  password: string;
};

export type Login200DataUser = {
  id?: Ulid;
  name?: string;
  email?: string;
  created_at?: string;
  updated_at?: string;
};

export type Login200Data = {
  user?: Login200DataUser;
};

export type Login200 = {
  data?: Login200Data;
  message?: string;
};

export type Login401 = {
  message?: string;
};

export type GetToken200AccessToken = {
  name: string;
  abilities: string[];
  expires_at: DateTime;
};

export type GetToken200 = {
  plainTextToken: string;
  accessToken: GetToken200AccessToken;
};

export type RegisterBody = {
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
};

export type Register201DataUser = {
  id?: Ulid;
  name?: string;
  email?: string;
  created_at?: string;
  updated_at?: string;
};

export type Register201Data = {
  user?: Register201DataUser;
};

export type Register201 = {
  data?: Register201Data;
  message?: string;
};

export type Register422Errors = { [key: string]: unknown };

export type Register422 = {
  message?: string;
  errors?: Register422Errors;
};

export type Logout200 = {
  message?: string;
};

export type Logout401 = {
  message?: string;
};

export type CreateBrandAssociationGroup400 = {
  error?: string;
};

export type DeleteBrandAssociationGroup400 = {
  error?: string;
};

/**
 * The opaque, server-signed transcript from the previous turn, echoed verbatim. Null/omitted on the first turn.
 * @nullable
 */
export type PostOnboardingChatCompletionStreamBodySignedTranscript =
  SignedTranscript | null;

/**
 * Edits the user made to the profile sidebar since the last turn. Only known fields are honored; validated server-side.
 * @nullable
 */
export type PostOnboardingChatCompletionStreamBodyProfileEdits =
  OnboardingProfile | null;

/**
 * Streaming is OpenAI-only; included for parity with the non-streaming endpoint.
 * @nullable
 */
export type PostOnboardingChatCompletionStreamBodyProvider =
  | (typeof PostOnboardingChatCompletionStreamBodyProvider)[keyof typeof PostOnboardingChatCompletionStreamBodyProvider]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostOnboardingChatCompletionStreamBodyProvider = {
  openai: 'openai',
} as const;

export type PostOnboardingChatCompletionStreamBody = {
  /**
   * The user's typed message for this turn.
   * @maxLength 1000
   */
  userMessage: string;
  /**
   * The opaque, server-signed transcript from the previous turn, echoed verbatim. Null/omitted on the first turn.
   * @nullable
   */
  signedTranscript?: PostOnboardingChatCompletionStreamBodySignedTranscript;
  /**
   * Edits the user made to the profile sidebar since the last turn. Only known fields are honored; validated server-side.
   * @nullable
   */
  profileEdits?: PostOnboardingChatCompletionStreamBodyProfileEdits;
  /**
   * Streaming is OpenAI-only; included for parity with the non-streaming endpoint.
   * @nullable
   */
  provider?: PostOnboardingChatCompletionStreamBodyProvider;
};

export type GetBrandQueries200 = {
  queries: QueryObjects;
};

export type UpdateBrandQueriesBody = {
  queries: Queries;
};

export type UpdateBrandQueries200 = {
  message: string;
  queries: QueryObjects;
};

export type UpdateBrandQueries400 = {
  error: string;
};

export type UpdateBrandQueries422 = ValidationError | ModerationErrorResponse;

export type GetQuerySuggestions200 = {
  queries: Queries;
};

export type GetCurrentUser200Data = {
  /** @pattern ^usr_[a-z0-9]{9}$ */
  id?: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  displayName?: string;
  email?: string;
};

export type GetCurrentUser200BrandsItemStatus =
  (typeof GetCurrentUser200BrandsItemStatus)[keyof typeof GetCurrentUser200BrandsItemStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCurrentUser200BrandsItemStatus = {
  pendingSetup: 'pendingSetup',
  pendingQuerySelection: 'pendingQuerySelection',
  pendingBrandGrouping: 'pendingBrandGrouping',
  active: 'active',
  deleting: 'deleting',
  deleted: 'deleted',
} as const;

export type GetCurrentUser200BrandsItem = {
  id?: string;
  name?: string;
  status?: GetCurrentUser200BrandsItemStatus;
  lastAnalysisDate?: string;
  /** @minimum 0 */
  analysisCount?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  currentScore?: number;
};

export type GetCurrentUser200 = {
  data?: GetCurrentUser200Data;
  /** @minimum 0 */
  activeSubscriptions?: number;
  /** @minimum 0 */
  maxNumberOfActiveBrands?: number;
  isEligibleForFreeTrial?: boolean;
  /** @nullable */
  trialAnalysisCompletedAt?: string | null;
  /** @minimum 0 */
  numberOfActiveBrands?: number;
  brands?: GetCurrentUser200BrandsItem[];
};

export type GetAccountDebug200MyYoast = {
  weeklyLimit?: number;
  isEligibleForFreeTrial?: boolean;
  isEligibleForTrialAnalysis?: boolean;
};

export type GetAccountDebug200BrandsItem = {
  id?: string;
  name?: string;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  deletedAt?: string | null;
};

export type GetAccountDebug200AnalysesItem = {
  id?: string;
  brandId?: string;
  /** @nullable */
  brandName?: string | null;
  isTrial?: boolean;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  finishedAt?: string | null;
  /** @nullable */
  deletedAt?: string | null;
};

export type GetAccountDebug200 = {
  myYoast?: GetAccountDebug200MyYoast;
  brands?: GetAccountDebug200BrandsItem[];
  analyses?: GetAccountDebug200AnalysesItem[];
};
